import './IceBreakerPreview.pcss';
import React from 'react';
import classNames from 'classnames';
import UnicornCompany from 'assets/unicorn.png';
import { IceBreakerModel } from '@mm/state/model/IceBreakerModel';

type Props = {
  iceBreaker: IceBreakerModel;
  showGetStarted?: boolean;
  showLabel?: boolean;
  accountName?: string;
  forInstagram?: boolean;
};

export const IceBreakerPreview = ({
  iceBreaker,
  showGetStarted = false,
  showLabel = false,
  accountName,
  forInstagram,
}: Props) => {
  return (
    <div
      className={classNames('icebreaker-preview__container', {
        instagram: forInstagram,
      })}
    >
      {showLabel && <div className="icebreaker-preview__label">Preview</div>}
      <div className="icebreaker-preview__phone-preview">
        <div className="icebreaker-preview__phone-header">
          <img
            src={UnicornCompany}
            className="icebreaker-preview__unicorn-company"
          />
          <div className="icebreaker-preview__page-label">
            {accountName || 'UnicornCompany'}
          </div>
        </div>
        <div className="icebreaker-preview__icebreakers-content">
          {forInstagram && (
            <div className="icebreaker-preview__icebreakers-content_note">
              Tap to send a question suggested by {accountName}.
            </div>
          )}
          {iceBreaker?.buttons
            .filter(button => button.name)
            .sort((f, s) => f.sortOrder - s.sortOrder)
            .map((button, index) => (
              <div
                className="icebreaker-preview__icebreakers-button-preview"
                key={index}
              >
                {button.name}
              </div>
            ))}
        </div>
        {showGetStarted && (
          <div className="icebreaker-preview__footer">
            <div className="icebreaker-preview__get-started">Get Started</div>
          </div>
        )}
      </div>
    </div>
  );
};
